"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkForm = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_hook_form_1 = require("react-hook-form");
const Input_1 = require("../../../../ui/Fields/Input/Input");
const Checkbox_1 = require("../../../../ui/Fields/Checkbox/Checkbox");
const common_1 = require("../../../../Extensions/LinkExtension/common");
const Extensions_1 = require("../../../../Extensions/Extensions");
const validation_1 = require("../../../../utils/validation");
const Tabs_1 = require("../../../../ui/Tabs/Tabs");
const MatrixAsset_1 = require("../../../../ui/Fields/MatrixAsset/MatrixAsset");
const linkTypeOptions = {
    [Extensions_1.MarkName.AssetLink]: { label: 'From source' },
    [Extensions_1.MarkName.Link]: { label: 'From URL' },
};
const LinkForm = ({ data, onSubmit }) => {
    const { control, register, handleSubmit, setValue, watch, formState: { errors }, } = (0, react_hook_form_1.useForm)({
        defaultValues: data,
    });
    const linkType = watch('linkType') || Extensions_1.MarkName.AssetLink;
    return (react_1.default.createElement("form", { className: "squiz-fte-form", onSubmit: handleSubmit(onSubmit) },
        react_1.default.createElement("div", { className: "squiz-fte-form-group mb-4" },
            react_1.default.createElement(Tabs_1.Tabs, { value: linkType, options: linkTypeOptions, onChange: (value) => setValue('linkType', value) })),
        linkType === Extensions_1.MarkName.Link && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Input_1.Input, { label: "URL", required: true, error: errors?.link?.href?.message, ...register('link.href', {
                        required: 'URL is required',
                        validate: {
                            noEmptySpaces: validation_1.noEmptySpacesValidation,
                        },
                    }) })),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Input_1.Input, { label: "Text", required: true, error: errors?.text?.message, ...register('text', {
                        required: 'Text is required',
                        validate: {
                            noEmptySpaces: validation_1.noEmptySpacesValidation,
                        },
                    }) })),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Input_1.Input, { label: "Title", error: errors?.link?.title?.message, ...register('link.title') })),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Checkbox_1.Checkbox, { label: "Open link in new window", onChange: (value) => setValue('link.target', value), defaultChecked: data?.link?.target === common_1.LinkTarget.Blank, unchecked: common_1.LinkTarget.Self, checked: common_1.LinkTarget.Blank })))),
        linkType === Extensions_1.MarkName.AssetLink && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: "assetLink", rules: {
                        validate: (0, validation_1.hasProperties)('An asset must be selected', ['matrixIdentifier', 'matrixAssetId']),
                    }, render: ({ field: { onChange, value }, fieldState: { error } }) => (react_1.default.createElement(MatrixAsset_1.MatrixAsset, { modalTitle: "Insert link", value: value, onChange: onChange, error: error?.message })) })),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Input_1.Input, { label: "Text", required: true, error: errors?.text?.message, ...register('text', {
                        required: 'Text is required',
                        validate: {
                            noEmptySpaces: validation_1.noEmptySpacesValidation,
                        },
                    }) })),
            react_1.default.createElement("div", { className: (0, clsx_1.default)('squiz-fte-form-group mb-2') },
                react_1.default.createElement(Checkbox_1.Checkbox, { label: "Open link in new window", onChange: (value) => setValue('assetLink.target', value), defaultChecked: data?.assetLink?.target === '_blank', unchecked: '_self', checked: '_blank' }))))));
};
exports.LinkForm = LinkForm;
